import { defineComponent as _defineComponent } from 'vue'
import useOfferSorting, {
  FilterCategory, FilterKey,
  IFilteringMultiformElement,
  OfferFilters
} from '@/components/calculator/results/OfferSorting';
import {useSimulationStore} from '@/components/calculator/services/SimulationStore';
import {computed} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferFilterCheckbox',
  props: {
    filter: null,
    value: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  filter: OfferFilters;
  value?: boolean;
}





const store = useSimulationStore();

const isFilterDisabled = (filter: OfferFilters): boolean =>
  store.allOffers.filter((x) => filter.filterFunction(x)).length === 0 &&
!store.userInput?.offerFilters[filter.type];

const model = computed({
  get: () => props.value,
  set: (value) => emit('input', !!value),
});

return { __sfc: true,props, emit, store, isFilterDisabled, model }
}

})